import React from 'react';
import IafsTable from './IafsTable';

function EnergyIafsTable({ iafs }) {
  return (
    <IafsTable
      title="Compensi da fee energia"
      iafs={iafs}
      anchorId="iafs-energy"
    />
  );
}

export default EnergyIafsTable;
